{
  "en": {
    "{0} фото не подойдут и не войдут в обучение. Нажмите на снимок, чтобы заменить": "{0} photos won’t work and won’t be used for training. Tap a photo to replace it",
    "{0} фото не подойдёт и не войдёт в обучение. Нажмите на снимок, чтобы заменить": "{0} photo won’t work and won’t be used for training. Tap the photo to replace it",
    "«Вы · {0}» уже выбран за «Вы»: он в «Кто в кадре» на всех экранах, в каталоге персонажей и в «Профиле».": "“You · {0}” is already selected as “You”: it is in “Who’s in the frame” on every screen, in the character catalog and in “Profile”.",
    "Без очков, масок, шапок и фильтров": "No glasses, masks, hats or filters",
    "Без повторов": "No duplicates",
    "В кадре несколько людей": "Several people in the frame",
    "В ряду «Кто в кадре» и в каталоге он будет «Вы · {0}»": "In the “Who’s in the frame” row and in the catalog it will be “You · {0}”",
    "Вариант видите и используете только вы. Удалить его можно в «Профиле»": "Only you can see and use the variant. You can delete it in “Profile”",
    "Вариант готов": "Variant ready",
    "Вариант готов: новый начнётся с первого шага при следующем входе": "The variant is ready: a new one will start from the first step next time you open the screen",
    "Вариант не создан": "Variant not created",
    "Вариант обучен": "Variant trained",
    "Вариант собран": "Variant assembled",
    "Вариант уже создаётся: шаги вернутся, когда он будет готов": "The variant is already being created: the steps will come back when it is ready",
    "Ваш клон": "Your clone",
    "Взяли {0} фото: всего нужно не больше {1}": "Took {0} photos: no more than {1} are needed in total",
    "Вы · {0}": "You · {0}",
    "Голос «{0}» удалён. Выберите другой или оставьте на потом": "The voice “{0}” was deleted. Choose another one or leave it for later",
    "Голос варианта": "Variant voice",
    "Голос из каталога": "Voice from the catalog",
    "Голос можно выбрать у каждого кружка": "You can choose a voice for each video bubble",
    "Голос на месте": "Voice added",
    "Голоса STEOS и персонажей": "STEOS and character voices",
    "Дальше": "Next",
    "Двое в кадре": "Two in the frame",
    "Дети, публичные люди и фото без согласия не пройдут проверку, Circle не вернутся": "Children, public figures and photos without consent will not pass the check, and the Circle will not be refunded",
    "Дождитесь проверки фото": "Wait for the photo check",
    "Ещё {0} до минимума": "{0} more to reach the minimum",
    "Ещё учится, скоро будет готов": "Still training, will be ready soon",
    "Записать свой голос": "Record your voice",
    "Из «Вы» · подходит для обучения": "From “You” · suitable for training",
    "Из ваших фото: от {0} до {1} снимков, где хорошо видно лицо": "From your photos: {0} to {1} shots where the face is clearly visible",
    "Имя варианта": "Variant name",
    "Имя и стиль": "Name and style",
    "Как на фото": "As in the photo",
    "Какие фото подойдут": "Which photos work",
    "Клон ещё учится: выберите его, когда будет готов": "The clone is still training: choose it when it is ready",
    "Крупно": "Close-up",
    "Лица проверены": "Faces checked",
    "Лицо найдено": "Face found",
    "Лицо не найдено": "Face not found",
    "Можно дальше": "Ready to continue",
    "Можно закрыть: бот пришлёт вариант в чат, когда он будет готов.": "You can close this: the bot will send the variant to the chat when it is ready.",
    "Мой вариант": "My variant",
    "На снимках публичный человек или человек без согласия: такие варианты не делаем.": "The photos show a public figure or a person without consent: we do not make such variants.",
    "На фото я или у меня есть согласие": "It’s me in the photos or I have consent",
    "Набрано {0} из {1}": "{0} of {1} added",
    "Назовите вариант": "Name the variant",
    "Не подойдут": "Won’t work",
    "Не подойдёт: {0}": "Won’t work: {0}",
    "Не получилось создать вариант": "Could not create the variant",
    "Нет лица": "No face",
    "Нечёткий или маленький снимок": "Blurry or small photo",
    "Нечётко": "Blurry",
    "Новый вариант «Вы»": "New “You” variant",
    "Нужно от {0}": "At least {0} needed",
    "Нужно хотя бы {0} подходящих фото": "At least {0} suitable photos are needed",
    "Нужны фото: JPG или PNG": "Photos needed: JPG or PNG",
    "Обработка": "Processing",
    "Обработка начнётся после «Создать вариант»": "Processing will start after “Create variant”",
    "Объёмный": "Volumetric",
    "Обычно около {0} минут. Можно закрыть: бот пришлёт вариант в чат, когда он будет готов.": "Usually about {0} minutes. You can close this: the bot will send the variant to the chat when it is ready.",
    "Один человек": "One person",
    "Остановить": "Stop",
    "Отлично": "Excellent",
    "Отметьте согласие: на фото вы": "Confirm consent: it’s you in the photos",
    "По желанию: голос можно выбрать и у каждого кружка": "Optional: you can also choose a voice for each video bubble",
    "По желанию: им вариант говорит в кружках": "Optional: the variant speaks with this voice in video bubbles",
    "Повседневный": "Casual",
    "Повтор": "Duplicate",
    "Повтор {0}": "Duplicate of {0}",
    "Повтор фото {0}": "Duplicate of photo {0}",
    "Подойдут": "Will work",
    "Подходит для обучения": "Suitable for training",
    "Позже": "Later",
    "Послушать голос": "Listen to the voice",
    "Праздничный": "Festive",
    "Пример голоса пока недоступен": "The voice sample is not available yet",
    "Пробуем стиль": "Trying the style",
    "Проверяем": "Checking",
    "Проверяем лица": "Checking faces",
    "Проверяем снимок": "Checking the photo",
    "Проверяем: {0}": "Checking: {0}",
    "Раздел «Клон»: от 2 секунд речи": "“Clone” section: 2 seconds of speech",
    "Размыто": "Blurred",
    "Разные дни, свет, ракурсы и выражения": "Different days, lighting, angles and expressions",
    "Разный свет": "Different lighting",
    "Ракурсы": "Angles",
    "Резкий снимок": "Sharp photo",
    "Рисованный": "Drawn",
    "Селфи {0}.jpg": "Selfie {0}.jpg",
    "Селфи с камеры": "Selfie from the camera",
    "Собираем вариант": "Assembling the variant",
    "Создать вариант": "Create variant",
    "Создать вариант · {0} C": "Create variant · {0} C",
    "Создаём вариант": "Creating the variant",
    "Сократите имя варианта": "Shorten the variant name",
    "Спишем {0} один раз": "We will charge {0} once",
    "Сразу несколько": "Several at once",
    "Ставим голос": "Setting up the voice",
    "Такой снимок уже есть": "This photo is already there",
    "Только вы, лицо крупно и в фокусе": "Only you, face close-up and in focus",
    "Убрать фото {0}": "Remove photo {0}",
    "Уже {0} фото: больше не нужно": "Already {0} photos: no more are needed",
    "Учим вариант": "Training the variant",
    "Фильтры": "Filters",
    "Фото {0}: {1}": "Photo {0}: {1}",
    "Фото загружены": "Photos uploaded",
    "Фото из «Вы» уже здесь: {0}. Нужно от {1}, лучше от {2} до {3}": "Photos from “You” are already here: {0}. At least {1} are needed, {2} to {3} is better",
    "Хорошо": "Good",
    "Чем разнообразнее снимки, тем живее вариант": "The more varied the photos, the livelier the variant",
    "Чтобы вернуться к шагам, нажмите «Заменить фото»": "To go back to the steps, tap “Replace the photo”",
    "Чтобы вернуться к шагам, нажмите «К настройкам»": "To go back to the steps, tap “Back to settings”",
    "Шаг {0} из {1}": "Step {0} of {1}",
    "Шаг {0}: {1}": "Step {0}: {1}",
    "Шаги идут по порядку": "The steps go in order",
    "Эмоции": "Emotions",
    "без голоса": "no voice",
    "вариант не создан": "variant not created",
    "ваш клон": "your clone",
    "из {0} фото": "of {0} photos",
    "не подойдёт": "won’t work",
    "подходит": "suitable",
    "причина неизвестна": "reason unknown",
    "проверяем": "checking",
    "у вас {0}": "you have {0}"
  },
  "hy": {
    "{0} фото не подойдут и не войдут в обучение. Нажмите на снимок, чтобы заменить": "{0} լուսանկար հարմար չէ և չի օգտագործվի ուսուցման համար։ Հպեք լուսանկարին՝ այն փոխարինելու համար",
    "{0} фото не подойдёт и не войдёт в обучение. Нажмите на снимок, чтобы заменить": "{0} լուսանկարը հարմար չէ և չի օգտագործվի ուսուցման համար։ Հպեք լուսանկարին՝ այն փոխարինելու համար",
    "«Вы · {0}» уже выбран за «Вы»: он в «Кто в кадре» на всех экранах, в каталоге персонажей и в «Профиле».": "«Դուք · {0}»-ն արդեն ընտրված է որպես «Դուք»․ այն «Ով է կադրում»-ում է բոլոր էկրաններին, կերպարների կատալոգում և «Պրոֆիլ»-ում։",
    "Без очков, масок, шапок и фильтров": "Առանց ակնոցների, դիմակների, գլխարկների և ֆիլտրերի",
    "Без повторов": "Առանց կրկնությունների",
    "В кадре несколько людей": "Կադրում մի քանի մարդ կա",
    "В ряду «Кто в кадре» и в каталоге он будет «Вы · {0}»": "«Ով է կադրում» շարքում և կատալոգում այն կլինի «Դուք · {0}»",
    "Вариант видите и используете только вы. Удалить его можно в «Профиле»": "Տարբերակը տեսնում և օգտագործում եք միայն դուք։ Այն կարող եք ջնջել «Պրոֆիլ»-ում",
    "Вариант готов": "Տարբերակը պատրաստ է",
    "Вариант готов: новый начнётся с первого шага при следующем входе": "Տարբերակը պատրաստ է․ հաջորդ մուտքի ժամանակ նորը կսկսվի առաջին քայլից",
    "Вариант не создан": "Տարբերակը չի ստեղծվել",
    "Вариант обучен": "Տարբերակը սովորեցված է",
    "Вариант собран": "Տարբերակը հավաքված է",
    "Вариант уже создаётся: шаги вернутся, когда он будет готов": "Տարբերակն արդեն ստեղծվում է․ քայլերը կվերադառնան, երբ այն պատրաստ լինի",
    "Ваш клон": "Ձեր կլոնը",
    "Взяли {0} фото: всего нужно не больше {1}": "Վերցրինք {0} լուսանկար․ ընդամենը պետք է ոչ ավելի, քան {1}",
    "Вы · {0}": "Դուք · {0}",
    "Голос «{0}» удалён. Выберите другой или оставьте на потом": "«{0}» ձայնը ջնջվել է։ Ընտրեք մեկ ուրիշը կամ թողեք հետոյի համար",
    "Голос варианта": "Տարբերակի ձայնը",
    "Голос из каталога": "Ձայն կատալոգից",
    "Голос можно выбрать у каждого кружка": "Ձայնը կարելի է ընտրել յուրաքանչյուր շրջանաձև տեսանյութի համար",
    "Голос на месте": "Ձայնը տեղում է",
    "Голоса STEOS и персонажей": "STEOS-ի և կերպարների ձայներ",
    "Дальше": "Հաջորդը",
    "Двое в кадре": "Կադրում երկուսն են",
    "Дети, публичные люди и фото без согласия не пройдут проверку, Circle не вернутся": "Երեխաները, հանրային անձինք և առանց համաձայնության լուսանկարները չեն անցնի ստուգումը, Circle-ը չի վերադարձվի",
    "Дождитесь проверки фото": "Սպասեք լուսանկարների ստուգմանը",
    "Ещё {0} до минимума": "Եվս {0}՝ մինչև նվազագույնը",
    "Ещё учится, скоро будет готов": "Դեռ սովորում է, շուտով պատրաստ կլինի",
    "Записать свой голос": "Ձայնագրել ձեր ձայնը",
    "Из «Вы» · подходит для обучения": "«Դուք»-ից · հարմար է ուսուցման համար",
    "Из ваших фото: от {0} до {1} снимков, где хорошо видно лицо": "Ձեր լուսանկարներից՝ {0}-ից {1} կադր, որտեղ դեմքը լավ երևում է",
    "Имя варианта": "Տարբերակի անունը",
    "Имя и стиль": "Անուն և ոճ",
    "Как на фото": "Ինչպես լուսանկարում",
    "Какие фото подойдут": "Ինչ լուսանկարներ են հարմար",
    "Клон ещё учится: выберите его, когда будет готов": "Կլոնը դեռ սովորում է․ ընտրեք այն, երբ պատրաստ լինի",
    "Крупно": "Խոշոր պլան",
    "Лица проверены": "Դեմքերը ստուգված են",
    "Лицо найдено": "Դեմքը գտնվել է",
    "Лицо не найдено": "Դեմքը չի գտնվել",
    "Можно дальше": "Կարելի է շարունակել",
    "Можно закрыть: бот пришлёт вариант в чат, когда он будет готов.": "Կարող եք փակել․ բոտը տարբերակը կուղարկի չատ, երբ այն պատրաստ լինի։",
    "Мой вариант": "Իմ տարբերակը",
    "На снимках публичный человек или человек без согласия: такие варианты не делаем.": "Լուսանկարներում հանրային անձ կամ առանց համաձայնության մարդ կա․ նման տարբերակներ չենք ստեղծում։",
    "На фото я или у меня есть согласие": "Լուսանկարներում ես եմ կամ ունեմ համաձայնություն",
    "Набрано {0} из {1}": "Ավելացված է {0}-ը {1}-ից",
    "Назовите вариант": "Անվանեք տարբերակը",
    "Не подойдут": "Հարմար չեն",
    "Не подойдёт: {0}": "Հարմար չէ․ {0}",
    "Не получилось создать вариант": "Չհաջողվեց ստեղծել տարբերակը",
    "Нет лица": "Դեմք չկա",
    "Нечёткий или маленький снимок": "Անհստակ կամ փոքր լուսանկար",
    "Нечётко": "Անհստակ",
    "Новый вариант «Вы»": "Նոր «Դուք» տարբերակ",
    "Нужно от {0}": "Պետք է առնվազն {0}",
    "Нужно хотя бы {0} подходящих фото": "Անհրաժեշտ է առնվազն {0} հարմար լուսանկար",
    "Нужны фото: JPG или PNG": "Անհրաժեշտ են լուսանկարներ՝ JPG կամ PNG",
    "Обработка": "Մշակում",
    "Обработка начнётся после «Создать вариант»": "Մշակումը կսկսվի «Ստեղծել տարբերակ»-ից հետո",
    "Объёмный": "Ծավալային",
    "Обычно около {0} минут. Можно закрыть: бот пришлёт вариант в чат, когда он будет готов.": "Սովորաբար մոտ {0} րոպե։ Կարող եք փակել․ բոտը տարբերակը կուղարկի չատ, երբ այն պատրաստ լինի։",
    "Один человек": "Մեկ մարդ",
    "Остановить": "Կանգնեցնել",
    "Отлично": "Գերազանց",
    "Отметьте согласие: на фото вы": "Նշեք համաձայնությունը․ լուսանկարներում դուք եք",
    "По желанию: голос можно выбрать и у каждого кружка": "Ըստ ցանկության․ ձայնը կարելի է ընտրել նաև յուրաքանչյուր շրջանաձև տեսանյութի համար",
    "По желанию: им вариант говорит в кружках": "Ըստ ցանկության․ այս ձայնով է տարբերակը խոսում շրջանաձև տեսանյութերում",
    "Повседневный": "Առօրյա",
    "Повтор": "Կրկնություն",
    "Повтор {0}": "{0}-ի կրկնություն",
    "Повтор фото {0}": "{0} լուսանկարի կրկնություն",
    "Подойдут": "Հարմար են",
    "Подходит для обучения": "Հարմար է ուսուցման համար",
    "Позже": "Ավելի ուշ",
    "Послушать голос": "Լսել ձայնը",
    "Праздничный": "Տոնական",
    "Пример голоса пока недоступен": "Ձայնի օրինակն առայժմ անհասանելի է",
    "Пробуем стиль": "Փորձում ենք ոճը",
    "Проверяем": "Ստուգում ենք",
    "Проверяем лица": "Ստուգում ենք դեմքերը",
    "Проверяем снимок": "Ստուգում ենք լուսանկարը",
    "Проверяем: {0}": "Ստուգում ենք․ {0}",
    "Раздел «Клон»: от 2 секунд речи": "«Կլոն» բաժին․ 2 վայրկյան խոսք",
    "Размыто": "Մշուշոտ",
    "Разные дни, свет, ракурсы и выражения": "Տարբեր օրեր, լույս, անկյուններ և արտահայտություններ",
    "Разный свет": "Տարբեր լույս",
    "Ракурсы": "Անկյուններ",
    "Резкий снимок": "Հստակ լուսանկար",
    "Рисованный": "Նկարված",
    "Селфи {0}.jpg": "Սելֆի {0}.jpg",
    "Селфи с камеры": "Սելֆի տեսախցիկից",
    "Собираем вариант": "Հավաքում ենք տարբերակը",
    "Создать вариант": "Ստեղծել տարբերակ",
    "Создать вариант · {0} C": "Ստեղծել տարբերակ · {0} C",
    "Создаём вариант": "Ստեղծում ենք տարբերակը",
    "Сократите имя варианта": "Կրճատեք տարբերակի անունը",
    "Спишем {0} один раз": "Մեկ անգամ կգանձենք {0}",
    "Сразу несколько": "Միանգամից մի քանիսը",
    "Ставим голос": "Տեղադրում ենք ձայնը",
    "Такой снимок уже есть": "Այս լուսանկարն արդեն կա",
    "Только вы, лицо крупно и в фокусе": "Միայն դուք, դեմքը խոշոր և հստակ",
    "Убрать фото {0}": "Հեռացնել {0} լուսանկարը",
    "Уже {0} фото: больше не нужно": "Արդեն {0} լուսանկար կա․ ավելին պետք չէ",
    "Учим вариант": "Սովորեցնում ենք տարբերակը",
    "Фильтры": "Ֆիլտրեր",
    "Фото {0}: {1}": "Լուսանկար {0}․ {1}",
    "Фото загружены": "Լուսանկարները վերբեռնված են",
    "Фото из «Вы» уже здесь: {0}. Нужно от {1}, лучше от {2} до {3}": "«Դուք»-ի լուսանկարներն արդեն այստեղ են՝ {0}։ Պետք է առնվազն {1}, ավելի լավ է {2}-ից {3}",
    "Хорошо": "Լավ",
    "Чем разнообразнее снимки, тем живее вариант": "Որքան բազմազան են լուսանկարները, այնքան կենդանի է տարբերակը",
    "Чтобы вернуться к шагам, нажмите «Заменить фото»": "Քայլերին վերադառնալու համար սեղմեք «Փոխել լուսանկարը»",
    "Чтобы вернуться к шагам, нажмите «К настройкам»": "Քայլերին վերադառնալու համար սեղմեք «Վերադառնալ կարգավորումներին»",
    "Шаг {0} из {1}": "Քայլ {0}՝ {1}-ից",
    "Шаг {0}: {1}": "Քայլ {0}․ {1}",
    "Шаги идут по порядку": "Քայլերը հաջորդում են իրար",
    "Эмоции": "Հույզեր",
    "без голоса": "առանց ձայնի",
    "вариант не создан": "տարբերակը չի ստեղծվել",
    "ваш клон": "ձեր կլոնը",
    "из {0} фото": "{0} լուսանկարից",
    "не подойдёт": "հարմար չէ",
    "подходит": "հարմար է",
    "причина неизвестна": "պատճառն անհայտ է",
    "проверяем": "ստուգում ենք",
    "у вас {0}": "ձեզ մոտ՝ {0}"
  },
  "es": {
    "{0} фото не подойдут и не войдут в обучение. Нажмите на снимок, чтобы заменить": "{0} fotos no sirven y no se usarán para el entrenamiento. Toca una foto para cambiarla",
    "{0} фото не подойдёт и не войдёт в обучение. Нажмите на снимок, чтобы заменить": "{0} foto no sirve y no se usará para el entrenamiento. Toca la foto para cambiarla",
    "«Вы · {0}» уже выбран за «Вы»: он в «Кто в кадре» на всех экранах, в каталоге персонажей и в «Профиле».": "«Tú · {0}» ya está elegido como «Tú»: aparece en «Quién aparece en el fotograma» en todas las pantallas, en el catálogo de personajes y en «Perfil».",
    "Без очков, масок, шапок и фильтров": "Sin gafas, mascarillas, gorros ni filtros",
    "Без повторов": "Sin repeticiones",
    "В кадре несколько людей": "Hay varias personas en la foto",
    "В ряду «Кто в кадре» и в каталоге он будет «Вы · {0}»": "En la fila «Quién aparece en el fotograma» y en el catálogo será «Tú · {0}»",
    "Вариант видите и используете только вы. Удалить его можно в «Профиле»": "Solo tú ves y usas la variante. Puedes eliminarla en «Perfil»",
    "Вариант готов": "Variante lista",
    "Вариант готов: новый начнётся с первого шага при следующем входе": "La variante está lista: la próxima vez empezará una nueva desde el primer paso",
    "Вариант не создан": "No se ha creado la variante",
    "Вариант обучен": "Variante entrenada",
    "Вариант собран": "Variante montada",
    "Вариант уже создаётся: шаги вернутся, когда он будет готов": "La variante ya se está creando: los pasos volverán cuando esté lista",
    "Ваш клон": "Tu clon",
    "Взяли {0} фото: всего нужно не больше {1}": "Hemos tomado {0} fotos: en total no hacen falta más de {1}",
    "Вы · {0}": "Tú · {0}",
    "Голос «{0}» удалён. Выберите другой или оставьте на потом": "La voz «{0}» se ha eliminado. Elige otra o déjalo para más tarde",
    "Голос варианта": "Voz de la variante",
    "Голос из каталога": "Voz del catálogo",
    "Голос можно выбрать у каждого кружка": "Puedes elegir la voz en cada vídeo circular",
    "Голос на месте": "Voz añadida",
    "Голоса STEOS и персонажей": "Voces de STEOS y de personajes",
    "Дальше": "Siguiente",
    "Двое в кадре": "Dos en la foto",
    "Дети, публичные люди и фото без согласия не пройдут проверку, Circle не вернутся": "Niños, personas públicas y fotos sin consentimiento no pasarán la revisión, y los Circle no se devolverán",
    "Дождитесь проверки фото": "Espera a que se revisen las fotos",
    "Ещё {0} до минимума": "Faltan {0} para el mínimo",
    "Ещё учится, скоро будет готов": "Todavía está aprendiendo, pronto estará listo",
    "Записать свой голос": "Grabar tu voz",
    "Из «Вы» · подходит для обучения": "De «Tú» · sirve para el entrenamiento",
    "Из ваших фото: от {0} до {1} снимков, где хорошо видно лицо": "De tus fotos: de {0} a {1} imágenes en las que se vea bien la cara",
    "Имя варианта": "Nombre de la variante",
    "Имя и стиль": "Nombre y estilo",
    "Как на фото": "Como en la foto",
    "Какие фото подойдут": "Qué fotos sirven",
    "Клон ещё учится: выберите его, когда будет готов": "El clon todavía está aprendiendo: elígelo cuando esté listo",
    "Крупно": "De cerca",
    "Лица проверены": "Caras revisadas",
    "Лицо найдено": "Cara detectada",
    "Лицо не найдено": "No se detectó ninguna cara",
    "Можно дальше": "Puedes continuar",
    "Можно закрыть: бот пришлёт вариант в чат, когда он будет готов.": "Puedes cerrar: el bot enviará la variante al chat cuando esté lista.",
    "Мой вариант": "Mi variante",
    "На снимках публичный человек или человек без согласия: такие варианты не делаем.": "En las fotos aparece una persona pública o alguien sin consentimiento: no creamos variantes así.",
    "На фото я или у меня есть согласие": "Soy yo en las fotos o tengo su consentimiento",
    "Набрано {0} из {1}": "{0} de {1} añadidas",
    "Назовите вариант": "Ponle nombre a la variante",
    "Не подойдут": "No sirven",
    "Не подойдёт: {0}": "No sirve: {0}",
    "Не получилось создать вариант": "No se pudo crear la variante",
    "Нет лица": "Sin cara",
    "Нечёткий или маленький снимок": "Foto borrosa o pequeña",
    "Нечётко": "Borrosa",
    "Новый вариант «Вы»": "Nueva variante «Tú»",
    "Нужно от {0}": "Se necesitan al menos {0}",
    "Нужно хотя бы {0} подходящих фото": "Hacen falta al menos {0} fotos válidas",
    "Нужны фото: JPG или PNG": "Hacen falta fotos: JPG o PNG",
    "Обработка": "Procesamiento",
    "Обработка начнётся после «Создать вариант»": "El procesamiento empezará tras «Crear variante»",
    "Объёмный": "Volumétrico",
    "Обычно около {0} минут. Можно закрыть: бот пришлёт вариант в чат, когда он будет готов.": "Suele tardar unos {0} minutos. Puedes cerrar: el bot enviará la variante al chat cuando esté lista.",
    "Один человек": "Una persona",
    "Остановить": "Detener",
    "Отлично": "Excelente",
    "Отметьте согласие: на фото вы": "Marca el consentimiento: eres tú en las fotos",
    "По желанию: голос можно выбрать и у каждого кружка": "Opcional: también puedes elegir la voz en cada vídeo circular",
    "По желанию: им вариант говорит в кружках": "Opcional: con ella habla la variante en los vídeos circulares",
    "Повседневный": "Informal",
    "Повтор": "Repetida",
    "Повтор {0}": "Repite la {0}",
    "Повтор фото {0}": "Repite la foto {0}",
    "Подойдут": "Sirven",
    "Подходит для обучения": "Sirve para el entrenamiento",
    "Позже": "Más tarde",
    "Послушать голос": "Escuchar la voz",
    "Праздничный": "Festivo",
    "Пример голоса пока недоступен": "La muestra de voz aún no está disponible",
    "Пробуем стиль": "Probando el estilo",
    "Проверяем": "Revisando",
    "Проверяем лица": "Revisando las caras",
    "Проверяем снимок": "Revisando la foto",
    "Проверяем: {0}": "Revisando: {0}",
    "Раздел «Клон»: от 2 секунд речи": "Sección «Clon»: 2 segundos de voz",
    "Размыто": "Desenfocada",
    "Разные дни, свет, ракурсы и выражения": "Distintos días, luces, ángulos y expresiones",
    "Разный свет": "Luz distinta",
    "Ракурсы": "Ángulos",
    "Резкий снимок": "Foto nítida",
    "Рисованный": "Dibujado",
    "Селфи {0}.jpg": "Selfi {0}.jpg",
    "Селфи с камеры": "Selfi con la cámara",
    "Собираем вариант": "Montando la variante",
    "Создать вариант": "Crear variante",
    "Создать вариант · {0} C": "Crear variante · {0} C",
    "Создаём вариант": "Creando la variante",
    "Сократите имя варианта": "Acorta el nombre de la variante",
    "Спишем {0} один раз": "Se descontarán {0} una sola vez",
    "Сразу несколько": "Varias a la vez",
    "Ставим голос": "Configurando la voz",
    "Такой снимок уже есть": "Esta foto ya está",
    "Только вы, лицо крупно и в фокусе": "Solo tú, la cara de cerca y enfocada",
    "Убрать фото {0}": "Quitar la foto {0}",
    "Уже {0} фото: больше не нужно": "Ya hay {0} fotos: no hacen falta más",
    "Учим вариант": "Entrenando la variante",
    "Фильтры": "Filtros",
    "Фото {0}: {1}": "Foto {0}: {1}",
    "Фото загружены": "Fotos subidas",
    "Фото из «Вы» уже здесь: {0}. Нужно от {1}, лучше от {2} до {3}": "Las fotos de «Tú» ya están aquí: {0}. Hacen falta al menos {1}, mejor de {2} a {3}",
    "Хорошо": "Bien",
    "Чем разнообразнее снимки, тем живее вариант": "Cuanto más variadas las fotos, más viva la variante",
    "Чтобы вернуться к шагам, нажмите «Заменить фото»": "Para volver a los pasos, toca «Cambiar la foto»",
    "Чтобы вернуться к шагам, нажмите «К настройкам»": "Para volver a los pasos, toca «Volver a los ajustes»",
    "Шаг {0} из {1}": "Paso {0} de {1}",
    "Шаг {0}: {1}": "Paso {0}: {1}",
    "Шаги идут по порядку": "Los pasos van en orden",
    "Эмоции": "Emociones",
    "без голоса": "sin voz",
    "вариант не создан": "no se ha creado la variante",
    "ваш клон": "tu clon",
    "из {0} фото": "de {0} fotos",
    "не подойдёт": "no sirve",
    "подходит": "sirve",
    "причина неизвестна": "motivo desconocido",
    "проверяем": "revisando",
    "у вас {0}": "tienes {0}"
  },
  "de": {
    "{0} фото не подойдут и не войдут в обучение. Нажмите на снимок, чтобы заменить": "{0} Fotos passen nicht und werden nicht fürs Training verwendet. Tippen Sie auf ein Foto, um es zu ersetzen",
    "{0} фото не подойдёт и не войдёт в обучение. Нажмите на снимок, чтобы заменить": "{0} Foto passt nicht und wird nicht fürs Training verwendet. Tippen Sie auf das Foto, um es zu ersetzen",
    "«Вы · {0}» уже выбран за «Вы»: он в «Кто в кадре» на всех экранах, в каталоге персонажей и в «Профиле».": "„Sie · {0}“ ist bereits als „Sie“ ausgewählt: Die Variante steht auf allen Seiten unter „Wer ist im Bild“, im Figurenkatalog und im „Profil“.",
    "Без очков, масок, шапок и фильтров": "Ohne Brille, Maske, Mütze und Filter",
    "Без повторов": "Keine Duplikate",
    "В кадре несколько людей": "Mehrere Personen im Bild",
    "В ряду «Кто в кадре» и в каталоге он будет «Вы · {0}»": "In der Reihe „Wer ist im Bild“ und im Katalog heißt die Variante „Sie · {0}“",
    "Вариант видите и используете только вы. Удалить его можно в «Профиле»": "Nur Sie sehen und nutzen die Variante. Löschen können Sie sie im „Profil“",
    "Вариант готов": "Variante fertig",
    "Вариант готов: новый начнётся с первого шага при следующем входе": "Die Variante ist fertig: Beim nächsten Öffnen beginnt eine neue mit dem ersten Schritt",
    "Вариант не создан": "Variante wurde nicht erstellt",
    "Вариант обучен": "Variante trainiert",
    "Вариант собран": "Variante zusammengestellt",
    "Вариант уже создаётся: шаги вернутся, когда он будет готов": "Die Variante wird bereits erstellt: Die Schritte sind wieder verfügbar, sobald sie fertig ist",
    "Ваш клон": "Ihr Klon",
    "Взяли {0} фото: всего нужно не больше {1}": "{0} Fotos übernommen: Insgesamt werden höchstens {1} benötigt",
    "Вы · {0}": "Sie · {0}",
    "Голос «{0}» удалён. Выберите другой или оставьте на потом": "Die Stimme „{0}“ wurde gelöscht. Wählen Sie eine andere oder entscheiden Sie später",
    "Голос варианта": "Stimme der Variante",
    "Голос из каталога": "Stimme aus dem Katalog",
    "Голос можно выбрать у каждого кружка": "Die Stimme können Sie bei jedem Rundvideo wählen",
    "Голос на месте": "Stimme hinzugefügt",
    "Голоса STEOS и персонажей": "Stimmen von STEOS und Figuren",
    "Дальше": "Weiter",
    "Двое в кадре": "Zwei im Bild",
    "Дети, публичные люди и фото без согласия не пройдут проверку, Circle не вернутся": "Kinder, Personen des öffentlichen Lebens und Fotos ohne Einwilligung bestehen die Prüfung nicht, die Circle werden nicht erstattet",
    "Дождитесь проверки фото": "Warten Sie die Fotoprüfung ab",
    "Ещё {0} до минимума": "Noch {0} bis zum Minimum",
    "Ещё учится, скоро будет готов": "Wird noch trainiert, bald fertig",
    "Записать свой голос": "Eigene Stimme aufnehmen",
    "Из «Вы» · подходит для обучения": "Aus „Sie“ · für das Training geeignet",
    "Из ваших фото: от {0} до {1} снимков, где хорошо видно лицо": "Aus Ihren Fotos: {0} bis {1} Aufnahmen, auf denen das Gesicht gut zu sehen ist",
    "Имя варианта": "Name der Variante",
    "Имя и стиль": "Name und Stil",
    "Как на фото": "Wie auf dem Foto",
    "Какие фото подойдут": "Welche Fotos passen",
    "Клон ещё учится: выберите его, когда будет готов": "Der Klon wird noch trainiert: Wählen Sie ihn, sobald er fertig ist",
    "Крупно": "Nahaufnahme",
    "Лица проверены": "Gesichter geprüft",
    "Лицо найдено": "Gesicht erkannt",
    "Лицо не найдено": "Kein Gesicht erkannt",
    "Можно дальше": "Weiter möglich",
    "Можно закрыть: бот пришлёт вариант в чат, когда он будет готов.": "Sie können schließen: Der Bot schickt die Variante in den Chat, sobald sie fertig ist.",
    "Мой вариант": "Meine Variante",
    "На снимках публичный человек или человек без согласия: такие варианты не делаем.": "Auf den Fotos ist eine Person des öffentlichen Lebens oder jemand ohne Einwilligung zu sehen: Solche Varianten erstellen wir nicht.",
    "На фото я или у меня есть согласие": "Auf den Fotos bin ich oder ich habe eine Einwilligung",
    "Набрано {0} из {1}": "{0} von {1} hinzugefügt",
    "Назовите вариант": "Benennen Sie die Variante",
    "Не подойдут": "Passen nicht",
    "Не подойдёт: {0}": "Passt nicht: {0}",
    "Не получилось создать вариант": "Variante konnte nicht erstellt werden",
    "Нет лица": "Kein Gesicht",
    "Нечёткий или маленький снимок": "Unscharfes oder kleines Foto",
    "Нечётко": "Unscharf",
    "Новый вариант «Вы»": "Neue Variante „Sie“",
    "Нужно от {0}": "Mindestens {0} nötig",
    "Нужно хотя бы {0} подходящих фото": "Es werden mindestens {0} passende Fotos benötigt",
    "Нужны фото: JPG или PNG": "Fotos benötigt: JPG oder PNG",
    "Обработка": "Verarbeitung",
    "Обработка начнётся после «Создать вариант»": "Die Verarbeitung beginnt nach „Variante erstellen“",
    "Объёмный": "Plastisch",
    "Обычно около {0} минут. Можно закрыть: бот пришлёт вариант в чат, когда он будет готов.": "Dauert meist etwa {0} Minuten. Sie können schließen: Der Bot schickt die Variante in den Chat, sobald sie fertig ist.",
    "Один человек": "Eine Person",
    "Остановить": "Stoppen",
    "Отлично": "Ausgezeichnet",
    "Отметьте согласие: на фото вы": "Bestätigen Sie die Einwilligung: Auf den Fotos sind Sie",
    "По желанию: голос можно выбрать и у каждого кружка": "Optional: Die Stimme können Sie auch bei jedem Rundvideo wählen",
    "По желанию: им вариант говорит в кружках": "Optional: Mit dieser Stimme spricht die Variante in Rundvideos",
    "Повседневный": "Alltag",
    "Повтор": "Duplikat",
    "Повтор {0}": "Duplikat von {0}",
    "Повтор фото {0}": "Duplikat von Foto {0}",
    "Подойдут": "Passen",
    "Подходит для обучения": "Für das Training geeignet",
    "Позже": "Später",
    "Послушать голос": "Stimme anhören",
    "Праздничный": "Festlich",
    "Пример голоса пока недоступен": "Die Stimmprobe ist noch nicht verfügbar",
    "Пробуем стиль": "Stil wird ausprobiert",
    "Проверяем": "Wird geprüft",
    "Проверяем лица": "Gesichter werden geprüft",
    "Проверяем снимок": "Foto wird geprüft",
    "Проверяем: {0}": "Prüfung: {0}",
    "Раздел «Клон»: от 2 секунд речи": "Bereich „Klon“: 2 Sekunden Sprache",
    "Размыто": "Verschwommen",
    "Разные дни, свет, ракурсы и выражения": "Verschiedene Tage, Licht, Blickwinkel und Gesichtsausdrücke",
    "Разный свет": "Anderes Licht",
    "Ракурсы": "Blickwinkel",
    "Резкий снимок": "Scharfes Foto",
    "Рисованный": "Gezeichnet",
    "Селфи {0}.jpg": "Selfie {0}.jpg",
    "Селфи с камеры": "Selfie mit der Kamera",
    "Собираем вариант": "Variante wird zusammengestellt",
    "Создать вариант": "Variante erstellen",
    "Создать вариант · {0} C": "Variante erstellen · {0} C",
    "Создаём вариант": "Variante wird erstellt",
    "Сократите имя варианта": "Kürzen Sie den Namen der Variante",
    "Спишем {0} один раз": "Wir buchen einmalig {0} ab",
    "Сразу несколько": "Mehrere auf einmal",
    "Ставим голос": "Stimme wird eingerichtet",
    "Такой снимок уже есть": "Dieses Foto gibt es schon",
    "Только вы, лицо крупно и в фокусе": "Nur Sie, Gesicht groß und scharf",
    "Убрать фото {0}": "Foto {0} entfernen",
    "Уже {0} фото: больше не нужно": "Bereits {0} Fotos: Mehr sind nicht nötig",
    "Учим вариант": "Variante wird trainiert",
    "Фильтры": "Filter",
    "Фото {0}: {1}": "Foto {0}: {1}",
    "Фото загружены": "Fotos hochgeladen",
    "Фото из «Вы» уже здесь: {0}. Нужно от {1}, лучше от {2} до {3}": "Fotos aus „Sie“ sind schon da: {0}. Mindestens {1} nötig, besser {2} bis {3}",
    "Хорошо": "Gut",
    "Чем разнообразнее снимки, тем живее вариант": "Je vielfältiger die Fotos, desto lebendiger die Variante",
    "Чтобы вернуться к шагам, нажмите «Заменить фото»": "Um zu den Schritten zurückzukehren, tippen Sie auf „Foto ersetzen“",
    "Чтобы вернуться к шагам, нажмите «К настройкам»": "Um zu den Schritten zurückzukehren, tippen Sie auf „Zurück zu den Einstellungen“",
    "Шаг {0} из {1}": "Schritt {0} von {1}",
    "Шаг {0}: {1}": "Schritt {0}: {1}",
    "Шаги идут по порядку": "Die Schritte folgen der Reihe nach",
    "Эмоции": "Emotionen",
    "без голоса": "ohne Stimme",
    "вариант не создан": "Variante nicht erstellt",
    "ваш клон": "Ihr Klon",
    "из {0} фото": "von {0} Fotos",
    "не подойдёт": "passt nicht",
    "подходит": "passt",
    "причина неизвестна": "Grund unbekannt",
    "проверяем": "wird geprüft",
    "у вас {0}": "Sie haben {0}"
  },
  "fr": {
    "{0} фото не подойдут и не войдут в обучение. Нажмите на снимок, чтобы заменить": "{0} photos ne conviennent pas et ne serviront pas à l’entraînement. Touchez une photo pour la remplacer",
    "{0} фото не подойдёт и не войдёт в обучение. Нажмите на снимок, чтобы заменить": "{0} photo ne convient pas et ne servira pas à l’entraînement. Touchez la photo pour la remplacer",
    "«Вы · {0}» уже выбран за «Вы»: он в «Кто в кадре» на всех экранах, в каталоге персонажей и в «Профиле».": "« Vous · {0} » est déjà choisi comme « Vous » : il apparaît dans « Personne dans le cadre » sur tous les écrans, dans le catalogue de personnages et dans « Profil ».",
    "Без очков, масок, шапок и фильтров": "Sans lunettes, masques, chapeaux ni filtres",
    "Без повторов": "Sans doublons",
    "В кадре несколько людей": "Plusieurs personnes dans le cadre",
    "В ряду «Кто в кадре» и в каталоге он будет «Вы · {0}»": "Dans la rangée « Personne dans le cadre » et dans le catalogue, il s’appellera « Vous · {0} »",
    "Вариант видите и используете только вы. Удалить его можно в «Профиле»": "Vous seul voyez et utilisez la variante. Vous pouvez la supprimer dans « Profil »",
    "Вариант готов": "Variante prête",
    "Вариант готов: новый начнётся с первого шага при следующем входе": "La variante est prête : la prochaine fois, une nouvelle commencera à la première étape",
    "Вариант не создан": "Variante non créée",
    "Вариант обучен": "Variante entraînée",
    "Вариант собран": "Variante assemblée",
    "Вариант уже создаётся: шаги вернутся, когда он будет готов": "La variante est déjà en cours de création : les étapes reviendront quand elle sera prête",
    "Ваш клон": "Votre clone",
    "Взяли {0} фото: всего нужно не больше {1}": "{0} photos ajoutées : il n’en faut pas plus de {1} au total",
    "Вы · {0}": "Vous · {0}",
    "Голос «{0}» удалён. Выберите другой или оставьте на потом": "La voix « {0} » a été supprimée. Choisissez-en une autre ou laissez pour plus tard",
    "Голос варианта": "Voix de la variante",
    "Голос из каталога": "Voix du catalogue",
    "Голос можно выбрать у каждого кружка": "Vous pouvez choisir la voix pour chaque vidéo ronde",
    "Голос на месте": "Voix ajoutée",
    "Голоса STEOS и персонажей": "Voix STEOS et des personnages",
    "Дальше": "Suivant",
    "Двое в кадре": "Deux dans le cadre",
    "Дети, публичные люди и фото без согласия не пройдут проверку, Circle не вернутся": "Les enfants, les personnalités publiques et les photos sans consentement ne passeront pas la vérification, les Circle ne seront pas remboursés",
    "Дождитесь проверки фото": "Attendez la vérification des photos",
    "Ещё {0} до минимума": "Encore {0} pour atteindre le minimum",
    "Ещё учится, скоро будет готов": "En cours d’entraînement, bientôt prêt",
    "Записать свой голос": "Enregistrer votre voix",
    "Из «Вы» · подходит для обучения": "De « Vous » · convient à l’entraînement",
    "Из ваших фото: от {0} до {1} снимков, где хорошо видно лицо": "À partir de vos photos : de {0} à {1} clichés où le visage est bien visible",
    "Имя варианта": "Nom de la variante",
    "Имя и стиль": "Nom et style",
    "Как на фото": "Comme sur la photo",
    "Какие фото подойдут": "Quelles photos conviennent",
    "Клон ещё учится: выберите его, когда будет готов": "Le clone est encore en entraînement : choisissez-le quand il sera prêt",
    "Крупно": "Gros plan",
    "Лица проверены": "Visages vérifiés",
    "Лицо найдено": "Visage détecté",
    "Лицо не найдено": "Visage non détecté",
    "Можно дальше": "Vous pouvez continuer",
    "Можно закрыть: бот пришлёт вариант в чат, когда он будет готов.": "Vous pouvez fermer : le bot enverra la variante dans le chat quand elle sera prête.",
    "Мой вариант": "Ma variante",
    "На снимках публичный человек или человек без согласия: такие варианты не делаем.": "Les photos montrent une personnalité publique ou une personne sans son consentement : nous ne créons pas de telles variantes.",
    "На фото я или у меня есть согласие": "C’est moi sur les photos ou j’ai le consentement",
    "Набрано {0} из {1}": "{0} sur {1} ajoutées",
    "Назовите вариант": "Nommez la variante",
    "Не подойдут": "Ne conviennent pas",
    "Не подойдёт: {0}": "Ne convient pas : {0}",
    "Не получилось создать вариант": "Impossible de créer la variante",
    "Нет лица": "Pas de visage",
    "Нечёткий или маленький снимок": "Photo floue ou trop petite",
    "Нечётко": "Flou",
    "Новый вариант «Вы»": "Nouvelle variante « Vous »",
    "Нужно от {0}": "Il en faut au moins {0}",
    "Нужно хотя бы {0} подходящих фото": "Il faut au moins {0} photos adaptées",
    "Нужны фото: JPG или PNG": "Photos requises : JPG ou PNG",
    "Обработка": "Traitement",
    "Обработка начнётся после «Создать вариант»": "Le traitement commencera après « Créer la variante »",
    "Объёмный": "En relief",
    "Обычно около {0} минут. Можно закрыть: бот пришлёт вариант в чат, когда он будет готов.": "Environ {0} minutes en général. Vous pouvez fermer : le bot enverra la variante dans le chat quand elle sera prête.",
    "Один человек": "Une seule personne",
    "Остановить": "Arrêter",
    "Отлично": "Excellent",
    "Отметьте согласие: на фото вы": "Cochez le consentement : c’est vous sur les photos",
    "По желанию: голос можно выбрать и у каждого кружка": "Facultatif : vous pouvez aussi choisir la voix pour chaque vidéo ronde",
    "По желанию: им вариант говорит в кружках": "Facultatif : la variante parle avec cette voix dans les vidéos rondes",
    "Повседневный": "Décontracté",
    "Повтор": "Doublon",
    "Повтор {0}": "Doublon de {0}",
    "Повтор фото {0}": "Doublon de la photo {0}",
    "Подойдут": "Conviennent",
    "Подходит для обучения": "Convient à l’entraînement",
    "Позже": "Plus tard",
    "Послушать голос": "Écouter la voix",
    "Праздничный": "Festif",
    "Пример голоса пока недоступен": "L’extrait de voix n’est pas encore disponible",
    "Пробуем стиль": "Essai du style",
    "Проверяем": "Vérification",
    "Проверяем лица": "Vérification des visages",
    "Проверяем снимок": "Vérification de la photo",
    "Проверяем: {0}": "Vérification : {0}",
    "Раздел «Клон»: от 2 секунд речи": "Section « Clone » : 2 secondes de parole",
    "Размыто": "Floue",
    "Разные дни, свет, ракурсы и выражения": "Différents jours, éclairages, angles et expressions",
    "Разный свет": "Éclairage varié",
    "Ракурсы": "Angles",
    "Резкий снимок": "Photo nette",
    "Рисованный": "Dessiné",
    "Селфи {0}.jpg": "Selfie {0}.jpg",
    "Селфи с камеры": "Selfie avec la caméra",
    "Собираем вариант": "Assemblage de la variante",
    "Создать вариант": "Créer la variante",
    "Создать вариант · {0} C": "Créer la variante · {0} C",
    "Создаём вариант": "Création de la variante",
    "Сократите имя варианта": "Raccourcissez le nom de la variante",
    "Спишем {0} один раз": "Nous débiterons {0} une seule fois",
    "Сразу несколько": "Plusieurs à la fois",
    "Ставим голос": "Mise en place de la voix",
    "Такой снимок уже есть": "Cette photo est déjà là",
    "Только вы, лицо крупно и в фокусе": "Vous seul, le visage en gros plan et net",
    "Убрать фото {0}": "Retirer la photo {0}",
    "Уже {0} фото: больше не нужно": "Déjà {0} photos : pas besoin de plus",
    "Учим вариант": "Entraînement de la variante",
    "Фильтры": "Filtres",
    "Фото {0}: {1}": "Photo {0} : {1}",
    "Фото загружены": "Photos importées",
    "Фото из «Вы» уже здесь: {0}. Нужно от {1}, лучше от {2} до {3}": "Les photos de « Vous » sont déjà là : {0}. Il en faut au moins {1}, idéalement de {2} à {3}",
    "Хорошо": "Bien",
    "Чем разнообразнее снимки, тем живее вариант": "Plus les photos sont variées, plus la variante est vivante",
    "Чтобы вернуться к шагам, нажмите «Заменить фото»": "Pour revenir aux étapes, touchez « Remplacer la photo »",
    "Чтобы вернуться к шагам, нажмите «К настройкам»": "Pour revenir aux étapes, touchez « Retour aux réglages »",
    "Шаг {0} из {1}": "Étape {0} sur {1}",
    "Шаг {0}: {1}": "Étape {0} : {1}",
    "Шаги идут по порядку": "Les étapes se suivent dans l’ordre",
    "Эмоции": "Émotions",
    "без голоса": "sans voix",
    "вариант не создан": "variante non créée",
    "ваш клон": "votre clone",
    "из {0} фото": "sur {0} photos",
    "не подойдёт": "ne convient pas",
    "подходит": "convient",
    "причина неизвестна": "raison inconnue",
    "проверяем": "vérification",
    "у вас {0}": "vous avez {0}"
  },
  "pt": {
    "{0} фото не подойдут и не войдут в обучение. Нажмите на снимок, чтобы заменить": "{0} fotos não servem e não serão usadas no treino. Toque numa foto para trocá-la",
    "{0} фото не подойдёт и не войдёт в обучение. Нажмите на снимок, чтобы заменить": "{0} foto não serve e não será usada no treino. Toque na foto para trocá-la",
    "«Вы · {0}» уже выбран за «Вы»: он в «Кто в кадре» на всех экранах, в каталоге персонажей и в «Профиле».": "«Você · {0}» já está escolhido como «Você»: aparece em «Quem está no quadro» em todas as telas, no catálogo de personagens e no «Perfil».",
    "Без очков, масок, шапок и фильтров": "Sem óculos, máscaras, chapéus ou filtros",
    "Без повторов": "Sem repetições",
    "В кадре несколько людей": "Há várias pessoas na foto",
    "В ряду «Кто в кадре» и в каталоге он будет «Вы · {0}»": "Na fila «Quem está no quadro» e no catálogo será «Você · {0}»",
    "Вариант видите и используете только вы. Удалить его можно в «Профиле»": "Só você vê e usa a variante. Pode excluí-la no «Perfil»",
    "Вариант готов": "Variante pronta",
    "Вариант готов: новый начнётся с первого шага при следующем входе": "A variante está pronta: na próxima entrada uma nova começará pelo primeiro passo",
    "Вариант не создан": "Variante não criada",
    "Вариант обучен": "Variante treinada",
    "Вариант собран": "Variante montada",
    "Вариант уже создаётся: шаги вернутся, когда он будет готов": "A variante já está a ser criada: os passos voltam quando ela estiver pronta",
    "Ваш клон": "Seu clone",
    "Взяли {0} фото: всего нужно не больше {1}": "Pegamos {0} fotos: no total não são precisas mais de {1}",
    "Вы · {0}": "Você · {0}",
    "Голос «{0}» удалён. Выберите другой или оставьте на потом": "A voz «{0}» foi excluída. Escolha outra ou deixe para depois",
    "Голос варианта": "Voz da variante",
    "Голос из каталога": "Voz do catálogo",
    "Голос можно выбрать у каждого кружка": "Pode escolher a voz em cada vídeo circular",
    "Голос на месте": "Voz adicionada",
    "Голоса STEOS и персонажей": "Vozes da STEOS e de personagens",
    "Дальше": "Avançar",
    "Двое в кадре": "Duas pessoas",
    "Дети, публичные люди и фото без согласия не пройдут проверку, Circle не вернутся": "Crianças, figuras públicas e fotos sem consentimento não passarão na verificação, e os Circle não serão devolvidos",
    "Дождитесь проверки фото": "Aguarde a verificação das fotos",
    "Ещё {0} до минимума": "Faltam {0} para o mínimo",
    "Ещё учится, скоро будет готов": "Ainda a aprender, em breve estará pronto",
    "Записать свой голос": "Gravar sua voz",
    "Из «Вы» · подходит для обучения": "De «Você» · serve para o treino",
    "Из ваших фото: от {0} до {1} снимков, где хорошо видно лицо": "Das suas fotos: de {0} a {1} imagens em que o rosto aparece bem",
    "Имя варианта": "Nome da variante",
    "Имя и стиль": "Nome e estilo",
    "Как на фото": "Como na foto",
    "Какие фото подойдут": "Que fotos servem",
    "Клон ещё учится: выберите его, когда будет готов": "O clone ainda está a aprender: escolha-o quando estiver pronto",
    "Крупно": "De perto",
    "Лица проверены": "Rostos verificados",
    "Лицо найдено": "Rosto encontrado",
    "Лицо не найдено": "Rosto não encontrado",
    "Можно дальше": "Pode continuar",
    "Можно закрыть: бот пришлёт вариант в чат, когда он будет готов.": "Pode fechar: o bot enviará a variante para o chat quando estiver pronta.",
    "Мой вариант": "Minha variante",
    "На снимках публичный человек или человек без согласия: такие варианты не делаем.": "As fotos mostram uma figura pública ou alguém sem consentimento: não criamos variantes assim.",
    "На фото я или у меня есть согласие": "Sou eu nas fotos ou tenho consentimento",
    "Набрано {0} из {1}": "{0} de {1} adicionadas",
    "Назовите вариант": "Dê um nome à variante",
    "Не подойдут": "Não servem",
    "Не подойдёт: {0}": "Não serve: {0}",
    "Не получилось создать вариант": "Não foi possível criar a variante",
    "Нет лица": "Sem rosto",
    "Нечёткий или маленький снимок": "Foto desfocada ou pequena",
    "Нечётко": "Desfocada",
    "Новый вариант «Вы»": "Nova variante «Você»",
    "Нужно от {0}": "São precisas pelo menos {0}",
    "Нужно хотя бы {0} подходящих фото": "São precisas pelo menos {0} fotos adequadas",
    "Нужны фото: JPG или PNG": "São precisas fotos: JPG ou PNG",
    "Обработка": "Processamento",
    "Обработка начнётся после «Создать вариант»": "O processamento começa depois de «Criar variante»",
    "Объёмный": "Volumétrico",
    "Обычно около {0} минут. Можно закрыть: бот пришлёт вариант в чат, когда он будет готов.": "Normalmente cerca de {0} minutos. Pode fechar: o bot enviará a variante para o chat quando estiver pronta.",
    "Один человек": "Uma pessoa",
    "Остановить": "Parar",
    "Отлично": "Excelente",
    "Отметьте согласие: на фото вы": "Marque o consentimento: é você nas fotos",
    "По желанию: голос можно выбрать и у каждого кружка": "Opcional: também pode escolher a voz em cada vídeo circular",
    "По желанию: им вариант говорит в кружках": "Opcional: é com ela que a variante fala nos vídeos circulares",
    "Повседневный": "Casual",
    "Повтор": "Repetida",
    "Повтор {0}": "Repete a {0}",
    "Повтор фото {0}": "Repete a foto {0}",
    "Подойдут": "Servem",
    "Подходит для обучения": "Serve para o treino",
    "Позже": "Mais tarde",
    "Послушать голос": "Ouvir a voz",
    "Праздничный": "Festivo",
    "Пример голоса пока недоступен": "A amostra de voz ainda não está disponível",
    "Пробуем стиль": "A experimentar o estilo",
    "Проверяем": "A verificar",
    "Проверяем лица": "A verificar os rostos",
    "Проверяем снимок": "A verificar a foto",
    "Проверяем: {0}": "A verificar: {0}",
    "Раздел «Клон»: от 2 секунд речи": "Seção «Clone»: 2 segundos de fala",
    "Размыто": "Desfocada",
    "Разные дни, свет, ракурсы и выражения": "Dias, luz, ângulos e expressões diferentes",
    "Разный свет": "Luz diferente",
    "Ракурсы": "Ângulos",
    "Резкий снимок": "Foto nítida",
    "Рисованный": "Desenhado",
    "Селфи {0}.jpg": "Selfie {0}.jpg",
    "Селфи с камеры": "Selfie com a câmara",
    "Собираем вариант": "A montar a variante",
    "Создать вариант": "Criar variante",
    "Создать вариант · {0} C": "Criar variante · {0} C",
    "Создаём вариант": "A criar a variante",
    "Сократите имя варианта": "Encurte o nome da variante",
    "Спишем {0} один раз": "Vamos debitar {0} uma única vez",
    "Сразу несколько": "Várias de uma vez",
    "Ставим голос": "A configurar a voz",
    "Такой снимок уже есть": "Esta foto já está",
    "Только вы, лицо крупно и в фокусе": "Só você, o rosto de perto e em foco",
    "Убрать фото {0}": "Remover a foto {0}",
    "Уже {0} фото: больше не нужно": "Já há {0} fotos: não são precisas mais",
    "Учим вариант": "A treinar a variante",
    "Фильтры": "Filtros",
    "Фото {0}: {1}": "Foto {0}: {1}",
    "Фото загружены": "Fotos enviadas",
    "Фото из «Вы» уже здесь: {0}. Нужно от {1}, лучше от {2} до {3}": "As fotos de «Você» já estão aqui: {0}. São precisas pelo menos {1}, melhor de {2} a {3}",
    "Хорошо": "Bom",
    "Чем разнообразнее снимки, тем живее вариант": "Quanto mais variadas as fotos, mais viva a variante",
    "Чтобы вернуться к шагам, нажмите «Заменить фото»": "Para voltar aos passos, toque em «Trocar a foto»",
    "Чтобы вернуться к шагам, нажмите «К настройкам»": "Para voltar aos passos, toque em «Voltar às configurações»",
    "Шаг {0} из {1}": "Passo {0} de {1}",
    "Шаг {0}: {1}": "Passo {0}: {1}",
    "Шаги идут по порядку": "Os passos seguem por ordem",
    "Эмоции": "Emoções",
    "без голоса": "sem voz",
    "вариант не создан": "variante não criada",
    "ваш клон": "seu clone",
    "из {0} фото": "de {0} fotos",
    "не подойдёт": "não serve",
    "подходит": "serve",
    "причина неизвестна": "motivo desconhecido",
    "проверяем": "a verificar",
    "у вас {0}": "você tem {0}"
  },
  "tr": {
    "{0} фото не подойдут и не войдут в обучение. Нажмите на снимок, чтобы заменить": "{0} fotoğraf uygun değil ve eğitimde kullanılmayacak. Değiştirmek için fotoğrafa dokunun",
    "{0} фото не подойдёт и не войдёт в обучение. Нажмите на снимок, чтобы заменить": "{0} fotoğraf uygun değil ve eğitimde kullanılmayacak. Değiştirmek için fotoğrafa dokunun",
    "«Вы · {0}» уже выбран за «Вы»: он в «Кто в кадре» на всех экранах, в каталоге персонажей и в «Профиле».": "«Siz · {0}» zaten «Siz» olarak seçildi: tüm ekranlarda «Karede kim var» bölümünde, karakter kataloğunda ve «Profil» bölümünde yer alıyor.",
    "Без очков, масок, шапок и фильтров": "Gözlük, maske, şapka ve filtre olmadan",
    "Без повторов": "Tekrar yok",
    "В кадре несколько людей": "Karede birden fazla kişi var",
    "В ряду «Кто в кадре» и в каталоге он будет «Вы · {0}»": "«Karede kim var» satırında ve katalogda «Siz · {0}» olarak görünecek",
    "Вариант видите и используете только вы. Удалить его можно в «Профиле»": "Varyantı yalnızca siz görür ve kullanırsınız. «Profil» bölümünden silebilirsiniz",
    "Вариант готов": "Varyant hazır",
    "Вариант готов: новый начнётся с первого шага при следующем входе": "Varyant hazır: bir sonraki girişte yenisi ilk adımdan başlayacak",
    "Вариант не создан": "Varyant oluşturulmadı",
    "Вариант обучен": "Varyant eğitildi",
    "Вариант собран": "Varyant hazırlandı",
    "Вариант уже создаётся: шаги вернутся, когда он будет готов": "Varyant zaten oluşturuluyor: hazır olduğunda adımlar geri gelecek",
    "Ваш клон": "Klonunuz",
    "Взяли {0} фото: всего нужно не больше {1}": "{0} fotoğraf alındı: toplamda en fazla {1} gerekiyor",
    "Вы · {0}": "Siz · {0}",
    "Голос «{0}» удалён. Выберите другой или оставьте на потом": "«{0}» sesi silindi. Başka bir ses seçin veya sonraya bırakın",
    "Голос варианта": "Varyantın sesi",
    "Голос из каталога": "Katalogdan ses",
    "Голос можно выбрать у каждого кружка": "Sesi her yuvarlak videoda seçebilirsiniz",
    "Голос на месте": "Ses eklendi",
    "Голоса STEOS и персонажей": "STEOS ve karakter sesleri",
    "Дальше": "İleri",
    "Двое в кадре": "Karede iki kişi",
    "Дети, публичные люди и фото без согласия не пройдут проверку, Circle не вернутся": "Çocuklar, tanınmış kişiler ve izinsiz fotoğraflar kontrolden geçmez, Circle iade edilmez",
    "Дождитесь проверки фото": "Fotoğrafların kontrolünü bekleyin",
    "Ещё {0} до минимума": "Minimuma {0} kaldı",
    "Ещё учится, скоро будет готов": "Hâlâ eğitiliyor, yakında hazır olacak",
    "Записать свой голос": "Sesinizi kaydedin",
    "Из «Вы» · подходит для обучения": "«Siz» bölümünden · eğitim için uygun",
    "Из ваших фото: от {0} до {1} снимков, где хорошо видно лицо": "Fotoğraflarınızdan: yüzün net göründüğü {0} ile {1} arası kare",
    "Имя варианта": "Varyant adı",
    "Имя и стиль": "Ad ve stil",
    "Как на фото": "Fotoğraftaki gibi",
    "Какие фото подойдут": "Hangi fotoğraflar uygun",
    "Клон ещё учится: выберите его, когда будет готов": "Klon hâlâ eğitiliyor: hazır olduğunda seçin",
    "Крупно": "Yakın çekim",
    "Лица проверены": "Yüzler kontrol edildi",
    "Лицо найдено": "Yüz bulundu",
    "Лицо не найдено": "Yüz bulunamadı",
    "Можно дальше": "Devam edebilirsiniz",
    "Можно закрыть: бот пришлёт вариант в чат, когда он будет готов.": "Kapatabilirsiniz: varyant hazır olduğunda bot sohbete gönderecek.",
    "Мой вариант": "Varyantım",
    "На снимках публичный человек или человек без согласия: такие варианты не делаем.": "Fotoğraflarda tanınmış biri veya izni olmayan biri var: bu tür varyantlar oluşturmuyoruz.",
    "На фото я или у меня есть согласие": "Fotoğraflardaki benim veya iznim var",
    "Набрано {0} из {1}": "{1} fotoğraftan {0} eklendi",
    "Назовите вариант": "Varyanta bir ad verin",
    "Не подойдут": "Uygun değil",
    "Не подойдёт: {0}": "Uygun değil: {0}",
    "Не получилось создать вариант": "Varyant oluşturma başarısız oldu",
    "Нет лица": "Yüz yok",
    "Нечёткий или маленький снимок": "Bulanık veya küçük fotoğraf",
    "Нечётко": "Bulanık",
    "Новый вариант «Вы»": "Yeni «Siz» varyantı",
    "Нужно от {0}": "En az {0} gerekli",
    "Нужно хотя бы {0} подходящих фото": "En az {0} uygun fotoğraf gerekli",
    "Нужны фото: JPG или PNG": "Fotoğraf gerekli: JPG veya PNG",
    "Обработка": "İşleniyor",
    "Обработка начнётся после «Создать вариант»": "İşlem «Varyant oluştur» sonrasında başlayacak",
    "Объёмный": "Hacimli",
    "Обычно около {0} минут. Можно закрыть: бот пришлёт вариант в чат, когда он будет готов.": "Genellikle yaklaşık {0} dakika sürer. Kapatabilirsiniz: varyant hazır olduğunda bot sohbete gönderecek.",
    "Один человек": "Tek kişi",
    "Остановить": "Durdur",
    "Отлично": "Mükemmel",
    "Отметьте согласие: на фото вы": "Onayı işaretleyin: fotoğraflardaki sizsiniz",
    "По желанию: голос можно выбрать и у каждого кружка": "İsteğe bağlı: sesi her yuvarlak videoda da seçebilirsiniz",
    "По желанию: им вариант говорит в кружках": "İsteğe bağlı: varyant yuvarlak videolarda bu sesle konuşur",
    "Повседневный": "Günlük",
    "Повтор": "Tekrar",
    "Повтор {0}": "{0} ile aynı",
    "Повтор фото {0}": "{0}. fotoğrafla aynı",
    "Подойдут": "Uygun",
    "Подходит для обучения": "Eğitim için uygun",
    "Позже": "Daha sonra",
    "Послушать голос": "Sesi dinle",
    "Праздничный": "Şık",
    "Пример голоса пока недоступен": "Ses örneği henüz kullanılamıyor",
    "Пробуем стиль": "Stil deneniyor",
    "Проверяем": "Kontrol ediliyor",
    "Проверяем лица": "Yüzler kontrol ediliyor",
    "Проверяем снимок": "Fotoğraf kontrol ediliyor",
    "Проверяем: {0}": "Kontrol ediliyor: {0}",
    "Раздел «Клон»: от 2 секунд речи": "«Klon» bölümü: 2 saniyelik konuşma",
    "Размыто": "Bulanık",
    "Разные дни, свет, ракурсы и выражения": "Farklı günler, ışıklar, açılar ve ifadeler",
    "Разный свет": "Farklı ışık",
    "Ракурсы": "Açılar",
    "Резкий снимок": "Net fotoğraf",
    "Рисованный": "Çizim",
    "Селфи {0}.jpg": "Selfie {0}.jpg",
    "Селфи с камеры": "Kameradan selfie",
    "Собираем вариант": "Varyant hazırlanıyor",
    "Создать вариант": "Varyant oluştur",
    "Создать вариант · {0} C": "Varyant oluştur · {0} C",
    "Создаём вариант": "Varyant oluşturuluyor",
    "Сократите имя варианта": "Varyant adını kısaltın",
    "Спишем {0} один раз": "Bir kez {0} kesilecek",
    "Сразу несколько": "Aynı anda birkaç tane",
    "Ставим голос": "Ses ekleniyor",
    "Такой снимок уже есть": "Bu fotoğraf zaten var",
    "Только вы, лицо крупно и в фокусе": "Yalnızca siz, yüz yakından ve net",
    "Убрать фото {0}": "{0}. fotoğrafı kaldır",
    "Уже {0} фото: больше не нужно": "Zaten {0} fotoğraf var: daha fazlası gerekmiyor",
    "Учим вариант": "Varyant eğitiliyor",
    "Фильтры": "Filtreler",
    "Фото {0}: {1}": "Fotoğraf {0}: {1}",
    "Фото загружены": "Fotoğraflar yüklendi",
    "Фото из «Вы» уже здесь: {0}. Нужно от {1}, лучше от {2} до {3}": "«Siz» fotoğrafları zaten burada: {0}. En az {1} gerekli, {2}–{3} arası daha iyi",
    "Хорошо": "İyi",
    "Чем разнообразнее снимки, тем живее вариант": "Fotoğraflar ne kadar çeşitli olursa varyant o kadar canlı olur",
    "Чтобы вернуться к шагам, нажмите «Заменить фото»": "Adımlara dönmek için «Fotoğrafı değiştir» düğmesine dokunun",
    "Чтобы вернуться к шагам, нажмите «К настройкам»": "Adımlara dönmek için «Ayarlara dön» düğmesine dokunun",
    "Шаг {0} из {1}": "Adım {0}/{1}",
    "Шаг {0}: {1}": "Adım {0}: {1}",
    "Шаги идут по порядку": "Adımlar sırayla ilerler",
    "Эмоции": "Duygular",
    "без голоса": "sessiz",
    "вариант не создан": "varyant oluşturulmadı",
    "ваш клон": "klonunuz",
    "из {0} фото": "{0} fotoğraftan",
    "не подойдёт": "uygun değil",
    "подходит": "uygun",
    "причина неизвестна": "neden bilinmiyor",
    "проверяем": "kontrol ediliyor",
    "у вас {0}": "sizde {0} var"
  },
  "kk": {
    "{0} фото не подойдут и не войдут в обучение. Нажмите на снимок, чтобы заменить": "{0} фото жарамайды және оқытуға кірмейді. Ауыстыру үшін фотоны түртіңіз",
    "{0} фото не подойдёт и не войдёт в обучение. Нажмите на снимок, чтобы заменить": "{0} фото жарамайды және оқытуға кірмейді. Ауыстыру үшін фотоны түртіңіз",
    "«Вы · {0}» уже выбран за «Вы»: он в «Кто в кадре» на всех экранах, в каталоге персонажей и в «Профиле».": "«Сіз · {0}» «Сіз» ретінде таңдалып қойды: ол барлық экрандағы «Кадрда кім бар» бөлімінде, кейіпкерлер каталогында және «Профильде».",
    "Без очков, масок, шапок и фильтров": "Көзілдіріксіз, маскасыз, бас киімсіз және сүзгісіз",
    "Без повторов": "Қайталанусыз",
    "В кадре несколько людей": "Кадрда бірнеше адам бар",
    "В ряду «Кто в кадре» и в каталоге он будет «Вы · {0}»": "«Кадрда кім бар» қатарында және каталогта ол «Сіз · {0}» болады",
    "Вариант видите и используете только вы. Удалить его можно в «Профиле»": "Нұсқаны тек сіз көресіз және қолданасыз. Оны «Профильде» жоюға болады",
    "Вариант готов": "Нұсқа дайын",
    "Вариант готов: новый начнётся с первого шага при следующем входе": "Нұсқа дайын: келесі кіргенде жаңасы бірінші қадамнан басталады",
    "Вариант не создан": "Нұсқа жасалмады",
    "Вариант обучен": "Нұсқа үйретілді",
    "Вариант собран": "Нұсқа жиналды",
    "Вариант уже создаётся: шаги вернутся, когда он будет готов": "Нұсқа жасалып жатыр: дайын болғанда қадамдар қайтады",
    "Ваш клон": "Сіздің клоныңыз",
    "Взяли {0} фото: всего нужно не больше {1}": "{0} фото алынды: барлығы {1}-ден аспауы керек",
    "Вы · {0}": "Сіз · {0}",
    "Голос «{0}» удалён. Выберите другой или оставьте на потом": "«{0}» дауысы жойылды. Басқасын таңдаңыз немесе кейінге қалдырыңыз",
    "Голос варианта": "Нұсқаның дауысы",
    "Голос из каталога": "Каталогтан дауыс",
    "Голос можно выбрать у каждого кружка": "Дауысты әр дөңгелек видеода таңдауға болады",
    "Голос на месте": "Дауыс қосылды",
    "Голоса STEOS и персонажей": "STEOS және кейіпкерлер дауыстары",
    "Дальше": "Әрі қарай",
    "Двое в кадре": "Кадрда екеу",
    "Дети, публичные люди и фото без согласия не пройдут проверку, Circle не вернутся": "Балалар, көпшілікке танымал адамдар және келісімсіз фотолар тексеруден өтпейді, Circle қайтарылмайды",
    "Дождитесь проверки фото": "Фото тексерілгенше күтіңіз",
    "Ещё {0} до минимума": "Минимумға дейін тағы {0}",
    "Ещё учится, скоро будет готов": "Әлі үйреніп жатыр, жақында дайын болады",
    "Записать свой голос": "Өз дауысыңызды жазу",
    "Из «Вы» · подходит для обучения": "«Сіз» бөлімінен · оқытуға жарамды",
    "Из ваших фото: от {0} до {1} снимков, где хорошо видно лицо": "Фотоларыңыздан: бет анық көрінетін {0}–{1} сурет",
    "Имя варианта": "Нұсқа атауы",
    "Имя и стиль": "Атау және стиль",
    "Как на фото": "Фотодағыдай",
    "Какие фото подойдут": "Қандай фотолар жарайды",
    "Клон ещё учится: выберите его, когда будет готов": "Клон әлі үйреніп жатыр: дайын болғанда таңдаңыз",
    "Крупно": "Ірі планда",
    "Лица проверены": "Беттер тексерілді",
    "Лицо найдено": "Бет табылды",
    "Лицо не найдено": "Бет табылмады",
    "Можно дальше": "Әрі қарай өтуге болады",
    "Можно закрыть: бот пришлёт вариант в чат, когда он будет готов.": "Жабуға болады: нұсқа дайын болғанда бот оны чатқа жібереді.",
    "Мой вариант": "Менің нұсқам",
    "На снимках публичный человек или человек без согласия: такие варианты не делаем.": "Суреттерде көпшілікке танымал адам немесе келісімі жоқ адам бар: мұндай нұсқаларды жасамаймыз.",
    "На фото я или у меня есть согласие": "Фотода менмін немесе келісімім бар",
    "Набрано {0} из {1}": "{1}-ден {0} қосылды",
    "Назовите вариант": "Нұсқаға атау беріңіз",
    "Не подойдут": "Жарамайды",
    "Не подойдёт: {0}": "Жарамайды: {0}",
    "Не получилось создать вариант": "Нұсқаны жасау мүмкін болмады",
    "Нет лица": "Бет жоқ",
    "Нечёткий или маленький снимок": "Бұлыңғыр немесе кішкентай сурет",
    "Нечётко": "Бұлыңғыр",
    "Новый вариант «Вы»": "Жаңа «Сіз» нұсқасы",
    "Нужно от {0}": "Кемінде {0} керек",
    "Нужно хотя бы {0} подходящих фото": "Кемінде {0} жарамды фото керек",
    "Нужны фото: JPG или PNG": "Фото керек: JPG немесе PNG",
    "Обработка": "Өңдеу",
    "Обработка начнётся после «Создать вариант»": "Өңдеу «Нұсқа жасау» басылғаннан кейін басталады",
    "Объёмный": "Көлемді",
    "Обычно около {0} минут. Можно закрыть: бот пришлёт вариант в чат, когда он будет готов.": "Әдетте шамамен {0} минут. Жабуға болады: нұсқа дайын болғанда бот оны чатқа жібереді.",
    "Один человек": "Бір адам",
    "Остановить": "Тоқтату",
    "Отлично": "Тамаша",
    "Отметьте согласие: на фото вы": "Келісімді белгілеңіз: фотода сізсіз",
    "По желанию: голос можно выбрать и у каждого кружка": "Қалауыңыз бойынша: дауысты әр дөңгелек видеода да таңдауға болады",
    "По желанию: им вариант говорит в кружках": "Қалауыңыз бойынша: нұсқа дөңгелек видеоларда осы дауыспен сөйлейді",
    "Повседневный": "Күнделікті",
    "Повтор": "Қайталау",
    "Повтор {0}": "{0}-нің қайталауы",
    "Повтор фото {0}": "{0}-фотоның қайталауы",
    "Подойдут": "Жарайды",
    "Подходит для обучения": "Оқытуға жарамды",
    "Позже": "Кейінірек",
    "Послушать голос": "Дауысты тыңдау",
    "Праздничный": "Мерекелік",
    "Пример голоса пока недоступен": "Дауыс үлгісі әзірше қолжетімсіз",
    "Пробуем стиль": "Стильді байқап көрудеміз",
    "Проверяем": "Тексерудеміз",
    "Проверяем лица": "Беттерді тексерудеміз",
    "Проверяем снимок": "Суретті тексерудеміз",
    "Проверяем: {0}": "Тексерудеміз: {0}",
    "Раздел «Клон»: от 2 секунд речи": "«Клон» бөлімі: 2 секунд сөйлеу",
    "Размыто": "Бұлыңғыр",
    "Разные дни, свет, ракурсы и выражения": "Әртүрлі күндер, жарық, ракурстар және көңіл күйлер",
    "Разный свет": "Әртүрлі жарық",
    "Ракурсы": "Ракурстар",
    "Резкий снимок": "Анық сурет",
    "Рисованный": "Салынған",
    "Селфи {0}.jpg": "Селфи {0}.jpg",
    "Селфи с камеры": "Камерадан селфи",
    "Собираем вариант": "Нұсқаны жинаудамыз",
    "Создать вариант": "Нұсқа жасау",
    "Создать вариант · {0} C": "Нұсқа жасау · {0} C",
    "Создаём вариант": "Нұсқа жасалуда",
    "Сократите имя варианта": "Нұсқа атауын қысқартыңыз",
    "Спишем {0} один раз": "Бір рет {0} шегеріледі",
    "Сразу несколько": "Бірден бірнешеуі",
    "Ставим голос": "Дауысты орнатудамыз",
    "Такой снимок уже есть": "Мұндай сурет бар",
    "Только вы, лицо крупно и в фокусе": "Тек сіз, бет ірі және анық",
    "Убрать фото {0}": "{0}-фотоны алып тастау",
    "Уже {0} фото: больше не нужно": "Қазірдің өзінде {0} фото: көбірек керек емес",
    "Учим вариант": "Нұсқаны үйретудеміз",
    "Фильтры": "Сүзгілер",
    "Фото {0}: {1}": "{0}-фото: {1}",
    "Фото загружены": "Фотолар жүктелді",
    "Фото из «Вы» уже здесь: {0}. Нужно от {1}, лучше от {2} до {3}": "«Сіз» фотолары осында: {0}. Кемінде {1} керек, {2}–{3} болса жақсы",
    "Хорошо": "Жақсы",
    "Чем разнообразнее снимки, тем живее вариант": "Суреттер неғұрлым әртүрлі болса, нұсқа соғұрлым тірі болады",
    "Чтобы вернуться к шагам, нажмите «Заменить фото»": "Қадамдарға оралу үшін «Фотоны ауыстыру» түймесін басыңыз",
    "Чтобы вернуться к шагам, нажмите «К настройкам»": "Қадамдарға оралу үшін «Баптауларға оралу» түймесін басыңыз",
    "Шаг {0} из {1}": "{1} қадамның {0}-қадамы",
    "Шаг {0}: {1}": "{0}-қадам: {1}",
    "Шаги идут по порядку": "Қадамдар ретімен жүреді",
    "Эмоции": "Эмоциялар",
    "без голоса": "дауыссыз",
    "вариант не создан": "нұсқа жасалмады",
    "ваш клон": "сіздің клоныңыз",
    "из {0} фото": "{0} фотодан",
    "не подойдёт": "жарамайды",
    "подходит": "жарайды",
    "причина неизвестна": "себебі белгісіз",
    "проверяем": "тексерудеміз",
    "у вас {0}": "сізде {0}"
  },
  "uk": {
    "{0} фото не подойдут и не войдут в обучение. Нажмите на снимок, чтобы заменить": "{0} фото не підійдуть і не ввійдуть у навчання. Натисніть на знімок, щоб замінити",
    "{0} фото не подойдёт и не войдёт в обучение. Нажмите на снимок, чтобы заменить": "{0} фото не підійде і не ввійде в навчання. Натисніть на знімок, щоб замінити",
    "«Вы · {0}» уже выбран за «Вы»: он в «Кто в кадре» на всех экранах, в каталоге персонажей и в «Профиле».": "«Ви · {0}» уже вибрано за «Ви»: він у «Хто в кадрі» на всіх екранах, у каталозі персонажів і в «Профілі».",
    "Без очков, масок, шапок и фильтров": "Без окулярів, масок, шапок і фільтрів",
    "Без повторов": "Без повторів",
    "В кадре несколько людей": "У кадрі кілька людей",
    "В ряду «Кто в кадре» и в каталоге он будет «Вы · {0}»": "У ряду «Хто в кадрі» та в каталозі він буде «Ви · {0}»",
    "Вариант видите и используете только вы. Удалить его можно в «Профиле»": "Варіант бачите й використовуєте лише ви. Видалити його можна в «Профілі»",
    "Вариант готов": "Варіант готовий",
    "Вариант готов: новый начнётся с первого шага при следующем входе": "Варіант готовий: новий почнеться з першого кроку під час наступного входу",
    "Вариант не создан": "Варіант не створено",
    "Вариант обучен": "Варіант навчено",
    "Вариант собран": "Варіант зібрано",
    "Вариант уже создаётся: шаги вернутся, когда он будет готов": "Варіант уже створюється: кроки повернуться, коли він буде готовий",
    "Ваш клон": "Ваш клон",
    "Взяли {0} фото: всего нужно не больше {1}": "Взяли {0} фото: загалом потрібно не більше {1}",
    "Вы · {0}": "Ви · {0}",
    "Голос «{0}» удалён. Выберите другой или оставьте на потом": "Голос «{0}» видалено. Виберіть інший або залиште на потім",
    "Голос варианта": "Голос варіанта",
    "Голос из каталога": "Голос із каталогу",
    "Голос можно выбрать у каждого кружка": "Голос можна вибрати для кожного кружечка",
    "Голос на месте": "Голос на місці",
    "Голоса STEOS и персонажей": "Голоси STEOS і персонажів",
    "Дальше": "Далі",
    "Двое в кадре": "Двоє в кадрі",
    "Дети, публичные люди и фото без согласия не пройдут проверку, Circle не вернутся": "Діти, публічні люди та фото без згоди не пройдуть перевірку, Circle не повернуться",
    "Дождитесь проверки фото": "Дочекайтеся перевірки фото",
    "Ещё {0} до минимума": "Ще {0} до мінімуму",
    "Ещё учится, скоро будет готов": "Ще навчається, скоро буде готовий",
    "Записать свой голос": "Записати свій голос",
    "Из «Вы» · подходит для обучения": "З «Ви» · підходить для навчання",
    "Из ваших фото: от {0} до {1} снимков, где хорошо видно лицо": "З ваших фото: від {0} до {1} знімків, де добре видно обличчя",
    "Имя варианта": "Назва варіанта",
    "Имя и стиль": "Назва і стиль",
    "Как на фото": "Як на фото",
    "Какие фото подойдут": "Які фото підійдуть",
    "Клон ещё учится: выберите его, когда будет готов": "Клон ще навчається: виберіть його, коли буде готовий",
    "Крупно": "Крупно",
    "Лица проверены": "Обличчя перевірено",
    "Лицо найдено": "Обличчя знайдено",
    "Лицо не найдено": "Обличчя не знайдено",
    "Можно дальше": "Можна далі",
    "Можно закрыть: бот пришлёт вариант в чат, когда он будет готов.": "Можна закрити: бот надішле варіант у чат, коли він буде готовий.",
    "Мой вариант": "Мій варіант",
    "На снимках публичный человек или человек без согласия: такие варианты не делаем.": "На знімках публічна людина або людина без згоди: такі варіанти не створюємо.",
    "На фото я или у меня есть согласие": "На фото я або в мене є згода",
    "Набрано {0} из {1}": "Набрано {0} з {1}",
    "Назовите вариант": "Назвіть варіант",
    "Не подойдут": "Не підійдуть",
    "Не подойдёт: {0}": "Не підійде: {0}",
    "Не получилось создать вариант": "Не вдалося створити варіант",
    "Нет лица": "Немає обличчя",
    "Нечёткий или маленький снимок": "Нечіткий або малий знімок",
    "Нечётко": "Нечітко",
    "Новый вариант «Вы»": "Новий варіант «Ви»",
    "Нужно от {0}": "Потрібно від {0}",
    "Нужно хотя бы {0} подходящих фото": "Потрібно хоча б {0} відповідних фото",
    "Нужны фото: JPG или PNG": "Потрібні фото: JPG або PNG",
    "Обработка": "Обробка",
    "Обработка начнётся после «Создать вариант»": "Обробка почнеться після «Створити варіант»",
    "Объёмный": "Об’ємний",
    "Обычно около {0} минут. Можно закрыть: бот пришлёт вариант в чат, когда он будет готов.": "Зазвичай близько {0} хвилин. Можна закрити: бот надішле варіант у чат, коли він буде готовий.",
    "Один человек": "Одна людина",
    "Остановить": "Зупинити",
    "Отлично": "Чудово",
    "Отметьте согласие: на фото вы": "Позначте згоду: на фото ви",
    "По желанию: голос можно выбрать и у каждого кружка": "За бажанням: голос можна вибрати й для кожного кружечка",
    "По желанию: им вариант говорит в кружках": "За бажанням: ним варіант говорить у кружечках",
    "Повседневный": "Повсякденний",
    "Повтор": "Повтор",
    "Повтор {0}": "Повтор {0}",
    "Повтор фото {0}": "Повтор фото {0}",
    "Подойдут": "Підійдуть",
    "Подходит для обучения": "Підходить для навчання",
    "Позже": "Пізніше",
    "Послушать голос": "Послухати голос",
    "Праздничный": "Святковий",
    "Пример голоса пока недоступен": "Приклад голосу поки недоступний",
    "Пробуем стиль": "Пробуємо стиль",
    "Проверяем": "Перевіряємо",
    "Проверяем лица": "Перевіряємо обличчя",
    "Проверяем снимок": "Перевіряємо знімок",
    "Проверяем: {0}": "Перевіряємо: {0}",
    "Раздел «Клон»: от 2 секунд речи": "Розділ «Клон»: 2 секунд мовлення",
    "Размыто": "Розмито",
    "Разные дни, свет, ракурсы и выражения": "Різні дні, світло, ракурси та вирази обличчя",
    "Разный свет": "Різне світло",
    "Ракурсы": "Ракурси",
    "Резкий снимок": "Чіткий знімок",
    "Рисованный": "Мальований",
    "Селфи {0}.jpg": "Селфі {0}.jpg",
    "Селфи с камеры": "Селфі з камери",
    "Собираем вариант": "Збираємо варіант",
    "Создать вариант": "Створити варіант",
    "Создать вариант · {0} C": "Створити варіант · {0} C",
    "Создаём вариант": "Створюємо варіант",
    "Сократите имя варианта": "Скоротіть назву варіанта",
    "Спишем {0} один раз": "Спишемо {0} один раз",
    "Сразу несколько": "Одразу кілька",
    "Ставим голос": "Ставимо голос",
    "Такой снимок уже есть": "Такий знімок уже є",
    "Только вы, лицо крупно и в фокусе": "Тільки ви, обличчя крупно й у фокусі",
    "Убрать фото {0}": "Прибрати фото {0}",
    "Уже {0} фото: больше не нужно": "Уже {0} фото: більше не потрібно",
    "Учим вариант": "Навчаємо варіант",
    "Фильтры": "Фільтри",
    "Фото {0}: {1}": "Фото {0}: {1}",
    "Фото загружены": "Фото завантажено",
    "Фото из «Вы» уже здесь: {0}. Нужно от {1}, лучше от {2} до {3}": "Фото з «Ви» вже тут: {0}. Потрібно від {1}, краще від {2} до {3}",
    "Хорошо": "Добре",
    "Чем разнообразнее снимки, тем живее вариант": "Що різноманітніші знімки, то живіший варіант",
    "Чтобы вернуться к шагам, нажмите «Заменить фото»": "Щоб повернутися до кроків, натисніть «Замінити фото»",
    "Чтобы вернуться к шагам, нажмите «К настройкам»": "Щоб повернутися до кроків, натисніть «До налаштувань»",
    "Шаг {0} из {1}": "Крок {0} з {1}",
    "Шаг {0}: {1}": "Крок {0}: {1}",
    "Шаги идут по порядку": "Кроки йдуть по черзі",
    "Эмоции": "Емоції",
    "без голоса": "без голосу",
    "вариант не создан": "варіант не створено",
    "ваш клон": "ваш клон",
    "из {0} фото": "з {0} фото",
    "не подойдёт": "не підійде",
    "подходит": "підходить",
    "причина неизвестна": "причина невідома",
    "проверяем": "перевіряємо",
    "у вас {0}": "у вас {0}"
  },
  "zh": {
    "{0} фото не подойдут и не войдут в обучение. Нажмите на снимок, чтобы заменить": "{0} 张照片不合适，不会用于训练。点击照片即可替换",
    "{0} фото не подойдёт и не войдёт в обучение. Нажмите на снимок, чтобы заменить": "{0} 张照片不合适，不会用于训练。点击照片即可替换",
    "«Вы · {0}» уже выбран за «Вы»: он в «Кто в кадре» на всех экранах, в каталоге персонажей и в «Профиле».": "「你 · {0}」已被选为「你」：它会出现在所有页面的「画面中的人」、角色目录和「个人资料」中。",
    "Без очков, масок, шапок и фильтров": "不戴眼镜、口罩、帽子，不加滤镜",
    "Без повторов": "不要重复",
    "В кадре несколько людей": "画面中有多个人",
    "В ряду «Кто в кадре» и в каталоге он будет «Вы · {0}»": "在「画面中的人」一栏和目录中，它将显示为「你 · {0}」",
    "Вариант видите и используете только вы. Удалить его можно в «Профиле»": "该版本只有你能看到和使用。可以在「个人资料」中删除",
    "Вариант готов": "版本已就绪",
    "Вариант готов: новый начнётся с первого шага при следующем входе": "版本已就绪：下次进入时，新版本将从第一步开始",
    "Вариант не создан": "版本未创建",
    "Вариант обучен": "版本已训练",
    "Вариант собран": "版本已生成",
    "Вариант уже создаётся: шаги вернутся, когда он будет готов": "版本正在创建中：完成后会重新显示步骤",
    "Ваш клон": "你的克隆",
    "Взяли {0} фото: всего нужно не больше {1}": "已选 {0} 张照片：总共不超过 {1} 张",
    "Вы · {0}": "你 · {0}",
    "Голос «{0}» удалён. Выберите другой или оставьте на потом": "声音「{0}」已被删除。请选择其他声音，或稍后再选",
    "Голос варианта": "版本的声音",
    "Голос из каталога": "目录中的声音",
    "Голос можно выбрать у каждого кружка": "每个圆形视频都可以选择声音",
    "Голос на месте": "声音已添加",
    "Голоса STEOS и персонажей": "STEOS 和角色的声音",
    "Дальше": "下一步",
    "Двое в кадре": "画面中两个人",
    "Дети, публичные люди и фото без согласия не пройдут проверку, Circle не вернутся": "儿童、公众人物和未经同意的照片无法通过审核，Circle 不予退还",
    "Дождитесь проверки фото": "请等待照片审核",
    "Ещё {0} до минимума": "距最低要求还差 {0}",
    "Ещё учится, скоро будет готов": "仍在训练，很快就好",
    "Записать свой голос": "录制你的声音",
    "Из «Вы» · подходит для обучения": "来自「你」· 适合训练",
    "Из ваших фото: от {0} до {1} снимков, где хорошо видно лицо": "使用你的照片：{0} 到 {1} 张脸部清晰的照片",
    "Имя варианта": "版本名称",
    "Имя и стиль": "名称和风格",
    "Как на фото": "与照片一致",
    "Какие фото подойдут": "哪些照片适合",
    "Клон ещё учится: выберите его, когда будет готов": "克隆仍在训练中：准备好后再选择",
    "Крупно": "特写",
    "Лица проверены": "人脸已检查",
    "Лицо найдено": "已识别人脸",
    "Лицо не найдено": "未识别到人脸",
    "Можно дальше": "可以继续",
    "Можно закрыть: бот пришлёт вариант в чат, когда он будет готов.": "可以关闭：版本准备好后，机器人会发到聊天中。",
    "Мой вариант": "我的版本",
    "На снимках публичный человек или человек без согласия: такие варианты не делаем.": "照片中是公众人物或未经同意的人：此类版本我们不制作。",
    "На фото я или у меня есть согласие": "照片中是我本人，或我已获得同意",
    "Набрано {0} из {1}": "已添加 {0} / {1}",
    "Назовите вариант": "为版本命名",
    "Не подойдут": "不合适",
    "Не подойдёт: {0}": "不合适：{0}",
    "Не получилось создать вариант": "版本创建失败",
    "Нет лица": "无人脸",
    "Нечёткий или маленький снимок": "照片模糊或太小",
    "Нечётко": "模糊",
    "Новый вариант «Вы»": "新的「你」版本",
    "Нужно от {0}": "至少需要 {0}",
    "Нужно хотя бы {0} подходящих фото": "至少需要 {0} 张合适的照片",
    "Нужны фото: JPG или PNG": "需要照片：JPG 或 PNG",
    "Обработка": "处理中",
    "Обработка начнётся после «Создать вариант»": "点击「创建版本」后开始处理",
    "Объёмный": "立体",
    "Обычно около {0} минут. Можно закрыть: бот пришлёт вариант в чат, когда он будет готов.": "通常约 {0} 分钟。可以关闭：版本准备好后，机器人会发到聊天中。",
    "Один человек": "一个人",
    "Остановить": "停止",
    "Отлично": "优秀",
    "Отметьте согласие: на фото вы": "请确认同意：照片中是你本人",
    "По желанию: голос можно выбрать и у каждого кружка": "可选：也可以为每个圆形视频单独选择声音",
    "По желанию: им вариант говорит в кружках": "可选：版本在圆形视频中用这个声音说话",
    "Повседневный": "日常",
    "Повтор": "重复",
    "Повтор {0}": "与 {0} 重复",
    "Повтор фото {0}": "与照片 {0} 重复",
    "Подойдут": "合适",
    "Подходит для обучения": "适合训练",
    "Позже": "稍后",
    "Послушать голос": "试听声音",
    "Праздничный": "节日",
    "Пример голоса пока недоступен": "声音示例暂不可用",
    "Пробуем стиль": "正在试用风格",
    "Проверяем": "检查中",
    "Проверяем лица": "正在检查人脸",
    "Проверяем снимок": "正在检查照片",
    "Проверяем: {0}": "正在检查：{0}",
    "Раздел «Клон»: от 2 секунд речи": "「声音克隆」板块：2 秒语音",
    "Размыто": "模糊",
    "Разные дни, свет, ракурсы и выражения": "不同日子、光线、角度和表情",
    "Разный свет": "不同光线",
    "Ракурсы": "角度",
    "Резкий снимок": "清晰照片",
    "Рисованный": "手绘",
    "Селфи {0}.jpg": "自拍 {0}.jpg",
    "Селфи с камеры": "相机自拍",
    "Собираем вариант": "正在生成版本",
    "Создать вариант": "创建版本",
    "Создать вариант · {0} C": "创建版本 · {0} C",
    "Создаём вариант": "正在创建版本",
    "Сократите имя варианта": "请缩短版本名称",
    "Спишем {0} один раз": "一次性扣除 {0}",
    "Сразу несколько": "一次多张",
    "Ставим голос": "正在设置声音",
    "Такой снимок уже есть": "这张照片已经有了",
    "Только вы, лицо крупно и в фокусе": "只有你，脸部特写且对焦清晰",
    "Убрать фото {0}": "移除照片 {0}",
    "Уже {0} фото: больше не нужно": "已有 {0} 张照片：不需要更多了",
    "Учим вариант": "正在训练版本",
    "Фильтры": "筛选",
    "Фото {0}: {1}": "照片 {0}：{1}",
    "Фото загружены": "照片已上传",
    "Фото из «Вы» уже здесь: {0}. Нужно от {1}, лучше от {2} до {3}": "已包含来自「你」的照片：{0} 张。至少需要 {1} 张，最好 {2} 到 {3} 张",
    "Хорошо": "良好",
    "Чем разнообразнее снимки, тем живее вариант": "照片越多样，版本越生动",
    "Чтобы вернуться к шагам, нажмите «Заменить фото»": "要返回步骤，请点击「替换照片」",
    "Чтобы вернуться к шагам, нажмите «К настройкам»": "要返回步骤，请点击「返回设置」",
    "Шаг {0} из {1}": "第 {0} 步，共 {1} 步",
    "Шаг {0}: {1}": "第 {0} 步：{1}",
    "Шаги идут по порядку": "步骤按顺序进行",
    "Эмоции": "表情",
    "без голоса": "无声音",
    "вариант не создан": "版本未创建",
    "ваш клон": "你的克隆",
    "из {0} фото": "共 {0} 张照片",
    "не подойдёт": "不合适",
    "подходит": "合适",
    "причина неизвестна": "原因未知",
    "проверяем": "检查中",
    "у вас {0}": "你有 {0}"
  }
}
